<template>
  <v-container fluid class="pa-0 fill-height">
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="pa-4">
        <v-card flat class="fill-height elevation-1">
          <v-card-text class="pa-0">
            <v-list dense>
              <v-list-item
                v-for="row in attributes"
                :key="row.label || row.id"
                class="view-row"
                two-line
              >
                <v-list-item-content>

                  <!-- CUSTOM SLOT RENDERING -->
                  <template v-if="row.type === 'anchor'">
                    <slot :name="row.id" />
                  </template>

                  <!-- NORMAL FIELD RENDERING -->
                  <template v-else>
                    <v-list-item-title class="title-text">
                      <!-- SINGLE VALUE -->
                      <span v-if="!['date', 'datetime', 'array', 'file'].includes(row.type)">
                        <span
                          v-if="row.reference"
                          class="redirect"
                          @click="onClickReference(row, row.value)"
                        >
                          {{ row.value.name }}
                        </span>
                        <span v-else>
                          {{ row.value }}
                        </span>
                      </span>

                      <!-- ARRAY OF VALUES -->
                      <span v-else-if="row.type === 'array'">
                        <v-chip-group
                          column
                          class="mt-2"
                          active-class="primary--text"
                          tag
                          multiple
                        >
                          <v-chip
                            v-for="item in row.value"
                            :key="item.id"
                            small
                            outlined
                            @click="row.reference && onClickReference(row, item)"
                            class="ma-1 chip-text"
                          >
                            {{ item.name }}
                          </v-chip>
                        </v-chip-group>
                      </span>

                      <!-- DATE / DATETIME -->
                      <span v-else-if="['date', 'datetime'].includes(row.type)">
                        {{ displayDate(row.value, row.type) }}
                      </span>

                      <!-- FILE -->
                      <span v-else-if="row.type === 'file'">
                        <v-btn
                          text
                          color="primary"
                          dark
                          @click="row.onClick"
                        >
                          {{ row.display || 'View File' }}
                        </v-btn>
                      </span>
                    </v-list-item-title>

                    <v-list-item-subtitle class="subtitle-text">
                      {{ row.label }}
                    </v-list-item-subtitle>
                  </template>

                </v-list-item-content>
              </v-list-item>

            </v-list>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
/* Row separation */
.view-row {
  border-bottom: 1px solid #e0e0e0;
  padding-top: 12px;
  padding-bottom: 12px;
}
/* Reference links */
.redirect {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}
/* Titles & subtitles */
.title-text {
  font-size: 0.95rem !important; /* larger for readability */
  font-weight: 500;
}
.chip-text {
  font-size: 0.95rem !important;
}
.subtitle-text {
  font-size: 0.93rem !important;
  color: #616161;
}
/* Full-page stretch
.fill-height {
  min-height: 100vh;
} */
.v-card-text {
  overflow-x: auto; /* horizontal scroll if needed */
}
</style>

<script>
export default {
  props: {
    attributes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClickReference({ URLName }, { id }) {
      if (!URLName || !id) return;
      this.$router.push({ name: URLName, params: { id } });
    },
    displayDate(date, type) {
      const nDate = new Date(date);
      if (nDate instanceof Date && !Number.isNaN(nDate.getTime())) {
        return type === 'datetime'
          ? nDate.toLocaleString()
          : nDate.toLocaleDateString();
      }
      return '---';
    },
  },
};
</script>
